import { ArrayReducerRow } from '.'

export const extractData = <T>(data: ArrayReducerRow<T>[]): T[] =>
  data.map(({ data }) => data)
